import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  Collapse,
  useTheme,
  Box,
  useMediaQuery,
  Popover
} from "@mui/material";
import "./Sidebar.css";
import { MENU_DATA, ROLE_MENU_ACCESS } from "../../constants/params/constants";
import { useAuth } from "../../hooks/useAuth";
// import "./Sidebar.scss";

const Sidebar = ({ open = true, toggleSidebar }) => {
  const theme = useTheme();
  // const customColors = useSelector((state) => state.theme.customColors);
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { user } = useAuth();

  const [openMenus, setOpenMenus] = useState({});
  const [menuData, setMenuData] = useState(MENU_DATA || []);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeFloatingMenu, setActiveFloatingMenu] = useState(null);

  // Roles listed in ROLE_MENU_ACCESS only see their allowed menu names;
  // any other/unlisted role keeps seeing the full menuData unchanged.
  const allowedMenuNames = ROLE_MENU_ACCESS[user?.roleName?.toLowerCase()];
  const visibleMenuData = allowedMenuNames
    ? menuData.filter((m) => allowedMenuNames.includes(m.subMenuName))
    : menuData;

  const handleMenuClick = (menu, event) => {
    if (!menu.children?.length) {
      navigate(menu.routePath);
      if (isMobile) toggleSidebar();
      return;
    }

    if (!open && !isMobile) {
      setAnchorEl(event.currentTarget);
      setActiveFloatingMenu(menu);
      return;
    }
    setActiveFloatingMenu(menu);
    setOpenMenus((prev) => ({
      [menu.subMenuId]: !prev[menu.subMenuId]
    }));
  };

  const renderSubMenu = (items) => (<Box className="sub-menu">
      {items.map((item) => {
        const active = location.pathname === item.routePath;
        return (
          <ListItemButton
            key={item.subMenuId}
            onClick={() => navigate(item.routePath)}
            sx={{
              color: active ? '#3874ff' : '#525b75',
              pl: 4,
              fontSize: 13,
              fontWeight: 600
            }}
          >
            {item.subMenuName}
          </ListItemButton>
        );
      })}
    </Box>
  );

  return (
    <>
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? open : true}
        ModalProps={{
          keepMounted: true,
          onBackdropClick: toggleSidebar,
        }}
        onClose={toggleSidebar}
        className={`dash-sidebar ${open ? "open" : "closed"}`}
        PaperProps={{
          className: `dash-sidebar voilet-scroll-container ${open ? "open" : "closed"}`,
          sx: {
            // backgroundColor:'#000',
            // color: '#fff',
            position: isMobile ? "absolute" : "fixed",
            top: isMobile ? 0 : 0,
            left: 0,
            height: 'calc(100% - 64px)',
            marginTop: '64px',
            width: open ? 250 : 60,
            transform: isMobile && !open ? "translateX(-100%)" : "translateX(0)",
            transition: "transform 0.3s ease-in-out, width 0.3s ease-in-out",
            zIndex: 1,
          },
        }}
      >
        {/* <Box className="sidebar-header">
          {open ? (
            <img src="/assets/images/logo/brandlogo.png" alt="logo" width={150} />
          ) : (
            <img src="/assets/images/logo/mainlogo.png" alt="icon" width={30} />
          )}
        </Box> */}
        <Box sx={{ py: 2, pr: 1 }}>
          <List sx={{ p: 0 }}>
            {visibleMenuData && [...visibleMenuData]
  .sort((a, b) => a.sortOrder - b.sortOrder).filter((m) => m.isMenuShow)
              .map((menu) => {
                const activeChild = menu.children?.some((c) => c.routePath === location.pathname);
                const parentActive = location.pathname === menu.routePath || activeChild;
                // const IconComponent = getMenuIcon(menu.icon);

                return (
                  <Box key={menu.subMenuId}>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={(e) => handleMenuClick(menu, e)}
                        sx={{
                          // bgcolor: parentActive ? 'red' : "transparent",
                          color: parentActive ? '#3874ff' : '#525b75',
                          fontSize: 13,
                          fontWeight: 600
                        }}
                      >
                        <Box component={'span'} sx={{ fontSize: 10 }}>
                          {open && menu.children?.length > 0 && (
                            openMenus[menu.subMenuId] ? (
                              <i class="fa-solid fa-caret-large-down" style={{ transform: 'scale(0.8)', color: '#8a94ad' }}></i>
                            ) : (
                              <i class="fa-solid fa-caret-large-right" style={{ transform: 'scale(0.8)', color: '#8a94ad' }}></i>
                            )
                          )}
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          {/* <IconComponent size={20} /> */}
                          <span style={{ fontSize: 16 }}>{menu.menuIcon}</span>
                          {open && <span>{menu.subMenuName}</span>}
                        </Box>


                      </ListItemButton>
                    </ListItem>

                    {open && menu.children?.length > 0 && (
                      <Collapse in={openMenus[menu.subMenuId]}>
                        {renderSubMenu(menu.children)}
                      </Collapse>
                    )}
                  </Box>
                );
              })}
          </List>
        </Box>
      </Drawer>

      {/* Floating Menu for Closed Sidebar */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {activeFloatingMenu?.children?.map((child) => {
          return (
          <ListItemButton
            sx={{ fontSize: 13 }}
            key={child.subMenuId}
            onClick={() => navigate(child.routePath)}
          >
            {child.subMenuName}
          </ListItemButton>
        )})}
      </Popover>
    </>
  );
};

export default Sidebar;
